import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.ticketing.create');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-ticketing-create',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.ticketing.create/view.scss */
/* src/app/portal.ticketing.create/view.scss: no such file or directory */`],
})
export class PortalTicketingCreateComponent implements OnInit {
    public form: any = {
        title: '',
        content: '',
        category: '',
        priority: 'medium'
    };
    public categories: string[] = ['서버', '네트워크', '스토리지', '보안', '계정', '소프트웨어', '기타'];
    public submitting: boolean = false;
    public attachments: any[] = [];
    private maxAttachmentSize: number = 5 * 1024 * 1024;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public async submit() {
        if (!this.form.title.trim()) {
            await this.showAlert('제목을 입력해주세요.');
            return;
        }
        if (!this.form.content.trim()) {
            await this.showAlert('내용을 입력해주세요.');
            return;
        }
        if (!this.form.category) {
            await this.showAlert('분류를 선택해주세요.');
            return;
        }

        this.submitting = true;
        await this.service.render();

        const { code, data } = await wiz.call("create", {
            ...this.form,
            attachments: JSON.stringify(this.attachments)
        });
        this.submitting = false;
        await this.service.render();

        if (code === 200) {
            this.service.href("/tickets");
        }
    }

    public async selectAttachments() {
        const files: any = await this.service.file.select({ multiple: true });
        if (!files) return;
        for (const file of Array.from(files) as File[]) {
            if (file.size > this.maxAttachmentSize) {
                await this.showAlert(`${file.name} 파일은 5MB를 초과합니다.`);
                continue;
            }
            this.attachments.push({
                name: file.name,
                size: file.size,
                type: file.type,
                url: await this.readAsDataUrl(file)
            });
        }
        await this.service.render();
    }

    public removeAttachment(index: number) {
        this.attachments.splice(index, 1);
    }

    public attachmentName(file: any) {
        return file?.name || '첨부파일';
    }

    public attachmentMeta(file: any) {
        const parts: string[] = [];
        if (file?.type) parts.push(file.type);
        if (file?.size) parts.push(this.formatSize(file.size));
        return parts.join(' · ');
    }

    public attachmentExt(file: any) {
        const name = this.attachmentName(file);
        const ext = name.includes('.') ? name.split('.').pop() : '';
        return ext ? ext.toString().slice(0, 4).toUpperCase() : '';
    }

    private readAsDataUrl(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(file);
        });
    }

    private formatSize(size: any) {
        const value = Number(size);
        if (!value || Number.isNaN(value)) return size;
        if (value >= 1024 * 1024) return `${(value / 1024 / 1024).toFixed(1)}MB`;
        if (value >= 1024) return `${(value / 1024).toFixed(1)}KB`;
        return `${value}B`;
    }

    private async showAlert(message: string, status: string = 'warning') {
        return await this.service.modal.show({
            title: '알림',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: status,
            status: status
        });
    }
}

export default PortalTicketingCreateComponent;